"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBankAccounts = exports.getParties = void 0;
const common_1 = require("@finley-technologies/common");
const getParties = (facilityMechanics) => {
    const { parties: { borrowers, capitalProviders }, } = facilityMechanics;
    // Facility mechanics
    (0, common_1.finleyAssert)(borrowers.length === 1, `Credit agreement must contain 1 borrower, but found ${borrowers.length}.`);
    const borrower = {
        organizationId: borrowers[0].entity.id,
        name: borrowers[0].entity.name,
    };
    const lenders = capitalProviders.map((capitalProvider) => ({
        organizationId: capitalProvider.entity.id,
        name: capitalProvider.entity.name,
        commitment: {
            amount: capitalProvider.commitmentAmount.value,
            currency: capitalProvider.commitmentAmount.currency,
        },
    }));
    return {
        borrower,
        lenders,
    };
};
exports.getParties = getParties;
const getBankAccounts = (facilityMechanics) => {
    const { parties: { borrowers, capitalProviders }, } = facilityMechanics;
    const bankAccounts = [...borrowers, ...capitalProviders].reduce((accounts, party) => {
        party.bankAccounts.map((account) => accounts.push({
            id: account.entity.id,
            name: `${account.entity.name} (${account.entity.accountNumber})`,
            organizationId: party.entity.id,
        }));
        return accounts;
    }, []);
    return {
        bankAccounts,
    };
};
exports.getBankAccounts = getBankAccounts;
//# sourceMappingURL=facility.js.map